import { AbstractReport } from '../abstract-report.model';
import { AccessorsMutatorsDecorator } from '../../../../helpers/model';
import {Property} from "../../property.model";
import {AccountCancellation} from '../../account-cancellation.model';

export class SubscriptionCancellation extends AbstractReport {

    constructor(...params){

        super(...params);

        this.reasons_text = AccountCancellation.REASONS.map(reasons => {

            if(reasons.value & this.reasons){

                return reasons.label;
            }

            return null;

        }).filter(Boolean);
    }

    /**
     * @param {Object|Property} value
     * @returns {Property}
     */
    setProperty(value) {

        return value instanceof Property ? value : new Property(value);
    }

}

AccessorsMutatorsDecorator(
    'id',
    'cancellation_ident',
    'property_name',
    'email',
    'last_billed_date',
    'cancelled_at',
    'total',
    'property_id',
    'property',
    'reasons',
    'reasons_text',
    'comment',
    'will_use_another_provider',
    'recommendation_rate',
    'account_id',
)(SubscriptionCancellation);



// WEBPACK FOOTER //
// ./src/pms-api/models/reports/admin-report/subscription-cancellation.model.js